import { UserAccount } from '@/coreDomainsModule/entities/users';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { initPagingOptions } from '@/coreDomainsModule/paging';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IFilterInfoRepository } from '@/coreInfrastructureModule/interfaces/IFilterInfoRepository';
import { i18n } from '@/i18n';

/**
 * KPI設定用の担当者一覧を取得するユースケース
 */
export class GetAggregateBusinessResponsibleUsersForKpiUseCase {
  private repository: IFilterInfoRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IFilterInfoRepository) {
    this.repository = repository;
  }

  /**
   * KPI設定画面で利用する担当者一覧を取得し、表示向けに整形する
   */
  public async execute(): Promise<INetworkResult<UserAccount[], IError>> {
    try {
      const dummyPagingOptions = initPagingOptions(1000); // NOTE: BE側では202602現在使用していないのでダミーで置いている
      const result = await this.repository.getSupplierForecastResponsibleUserList(dummyPagingOptions);

      switch (result.status.type) {
        case 'success':
          // nullが返却される場合があるため、null以外をフィルターする
          const filteredResult = result.status.data.data.filterNotNull();

          if (!filteredResult.isEmpty()) {
            const collator = new Intl.Collator(i18n.locale, { numeric: true });
            filteredResult.sort((a, b) => {
              const userNameA = a.name === '' ? a.id : a.name;
              const userNameB = b.name === '' ? b.id : b.name;
              return collator.compare(userNameB, userNameA);
            });
          }
          const resultData = filteredResult.map((userInfo) => UserAccountFactory.create({ email: userInfo.id, name: userInfo.name }));
          if (result.status.data.data.length !== filteredResult.length)
            resultData.push(UserAccountFactory.create({ email: undefined, name: undefined }));
          return {
            status: {
              type: 'success',
              data: resultData,
            },
          };
        case 'error':
          console.error(result.status.error);
          return {
            status: {
              type: 'error',
              error: result.status.error,
            },
          };
        default:
          throw Error('想定外のエラー');
      }
    } catch (e) {
      console.error('error', e); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
